import { InvitesState } from './state';

export const invitesInitialState: InvitesState = {
  current: {
    team: {},
    owner: {},
    user: {},
    credits: {},
    collaborator: {},
    songwriter: {},
    'record-label': {},
    operator: {},
  },
  new: {
    team: {},
    owner: {},
    user: {},
    credits: {},
    collaborator: {},
    songwriter: {},
    'record-label': {},
    operator: {},
  },
  user: [],
  recordLabel: {
    team: [],
    owner: [],
    user: [],
    credits: [],
    collaborator: [],
    songwriter: [],
    'record-label': [],
    operator: [],
  },
  loaded: false,
};
